/**
 * Created by shubham on 11/4/18.
 */

/**
 * A model for an individual corporate employee
 */
/**
 * Created by shubham on 11/4/18.
 */

/**
 * A model for an individual corporate employee
 */
export class ApplicationsDashboardList {
    id:number;
    applicationId: number;
    applicationName: string;
    userId_WPASS: string;
    businessUnitId: number;
    businessUnitName: string;
    countryId: string;
    countryName: string;
    approverId: number;
    approverName: string;
    multipleRole: boolean;
    reason: string;
    status: string;
    statusCode: string;
    updatedAt: string;

    constructor(id:number, applicationId:number, applicationName:string, userId_WPASS:string, businessUnitId:number, businessUnitName:string,
                countryId:string, countryName:string, approverId:number, approverName: string, multipleRole: boolean, reason: string,
                status: string, statusCode:string, updatedAt: string){
        this.id = id;
        this.applicationId = applicationId;
        this.applicationName = applicationName;
        this.userId_WPASS = userId_WPASS;
        this.businessUnitId = businessUnitId;
        this.businessUnitName = businessUnitName;
        this.countryId = countryId;
        this.countryName = countryName;
        this.approverId = approverId;
        this.approverName = approverName;
        this.multipleRole = multipleRole;
        this.reason = reason;
        this.status = status;
        this.statusCode = statusCode;
        this.updatedAt = updatedAt;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/applications-manager-dashboard/applications-datatable/applications-dashboardList.ts